































import { Component, Vue, Prop } from 'vue-property-decorator';

type Type = 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'

interface imgConfig {
  url: string,
  fit?: Type,
  lazy?: boolean,
  srcList?: Array<any>,
  zIndex?: number,
  width?: number,
  height?: number,
  imgBar?: boolean,
  options?: Array<any>,
  load?: Function,
  error?: Function
}

@Component({
  name: 'dtImage'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private config!: imgConfig;
  private defaultConfig: any = {
    fit: 'fill',
    width: 100,
    height: 100,
    imgBar: true
  };

  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    return result;
  }

  // 打开放大图片预览
  open() {
    (this.$refs.previewImg as any).clickHandler();
  }

  // 按钮点击事件
  click(item: any) {
    item.onClick && item.onClick(item);
  }

  // 加载成功
  load(event: any) {
    this.config.load && this.config.load(event);
  }

  // 加载失败
  error(event: any) {
    this.config.error && this.config.error(event);
  }
}
